(() => {
  if (window.__cParallaxMediaInitialized) return;
  window.__cParallaxMediaInitialized = true;

  const init = () => {
  const texts = Array.from(document.querySelectorAll('.c_parallax-media__text'));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsIntersectionObserver = 'IntersectionObserver' in window;

  if (reducedMotion) {
    texts.forEach(el => el.classList.add('-visible'));
  } else if (!supportsIntersectionObserver) {
    texts.forEach(el => el.classList.add('-visible'));
  } else {
    const textObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('-visible');
        textObserver.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    texts.forEach(el => textObserver.observe(el));
  }

  const images = Array.from(document.querySelectorAll('.c_parallax-media__image img'));
  if (!images.length) return;

  if (reducedMotion || !supportsIntersectionObserver) return;

  const maxShift = 25;
  const lerp     = 0.10;

  const items = images.map(img => ({
    img,
    frameEl: img.closest('.c_parallax-media__image'),
    current: 0,
    top: 0,
    height: 0,
    rafId: null,
    tick: null,
  }));

  function calcMetrics() {
    items.forEach(item => {
      const rect   = item.frameEl.getBoundingClientRect();
      item.top     = rect.top + window.scrollY;
      item.height  = rect.height;
    });
  }

  function getTarget(item) {
    const vh     = window.innerHeight || 1;
    const center = (item.top - window.scrollY) + item.height / 2;
    const norm   = (center / vh - 0.5) * 2;
    return Math.max(-1, Math.min(1, norm)) * maxShift;
  }

  items.forEach(item => {
    function tick() {
      const target  = getTarget(item);
      item.current += (target - item.current) * lerp;

      if (Math.abs(target - item.current) < 0.1) item.current = target;

      item.img.style.transform = `translate3d(0, ${item.current.toFixed(2)}px, 0)`;
      item.rafId = requestAnimationFrame(tick);
    }
    item.tick = tick;
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const item = items.find(it => it.frameEl === entry.target);
      if (!item) return;

      if (entry.isIntersecting) {
        if (!item.rafId) item.rafId = requestAnimationFrame(item.tick);
      } else {
        if (item.rafId) { cancelAnimationFrame(item.rafId); item.rafId = null; }
      }
    });
  }, { threshold: 0, rootMargin: '100px 0px' });

  items.forEach(item => observer.observe(item.frameEl));

  window.addEventListener('resize', calcMetrics);
  window.addEventListener('load', calcMetrics);
  calcMetrics();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
